export default "__VITE_ASSET__CsMhFTk2__"